export default {
  init() {
    // JavaScript to be fired on the home page
    $(document).ready(function(){
      $('select.filterby').change(function() {

        var filters = $.map($('select.filterby').toArray(), function(e){
          return $(e).val();
        }).join('.');
        $('span#broker-container').find('span').hide();
        $('span#broker-container').find('span.' + filters).show();
      });

      $('#firstNameInput').keyup(function() {
        // Declare variables
        var input, filter, container, span, a, i, txtValue;
        input = document.getElementById('firstNameInput');
        filter = input.value.toUpperCase();
        container = document.getElementById('broker-container');
        span = container.getElementsByTagName('span');

        // Loop through all items, and hide those who don't match the search query
        for (i = 0; i < span.length; i++) {
          a = span[i].getElementsByTagName('h3')[0];
          txtValue = a.textContent || a.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            span[i].style.display = '';
          } else {
            span[i].style.display = 'none';
          }
        }
      });

      $('#lastNameInput').keyup(function() {
        // Declare variables
        var input, filter, container, span, a, i, txtValue;
        input = document.getElementById('lastNameInput');
        filter = input.value.toUpperCase();
        container = document.getElementById('broker-container');
        span = container.getElementsByTagName('span');

        // Loop through all items, and hide those who don't match the search query
        for (i = 0; i < span.length; i++) {
          a = span[i].getElementsByTagName('h4')[0];
          txtValue = a.textContent || a.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            span[i].style.display = '';
          } else {
            span[i].style.display = 'none';
          }
        }
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
